<template>
  <ion-page>
    <SkipLink></SkipLink>
    <ion-tabs>
      <ion-router-outlet id="main-content"></ion-router-outlet>
      <!--  Home | Learn | Jobs | Fav’s | Plan | Info -->
      <div class="navigation-container">
        <ion-tab-bar :class="tabbarImage" data-test="tab-bar" slot="bottom">
          <nav aria-label="global">
            <ion-tab-button
              @keydown.enter="$router.push({ name: 'Home' })"
              tab="home"
              href="/tabs/home"
              data-test="home-tab"
            >
              <ion-icon aria-hidden="true" :icon="homeOutline"></ion-icon>
              <ion-label aria-label="Home">{{ $t("tabs.home") }}</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="learn-tab"
              v-if="
                featureFlagStore.isFlagEnabled(
                  'release-page-learn-and-grow-home',
                  true
                )
              "
              @keydown.enter="$router.push({ name: 'Learn and Grow' })"
              tab="learn"
              href="/tabs/learn-home"
            >
              <ion-icon aria-hidden="true" :icon="trophyOutline" />
              <ion-label aria-label="Learn">{{ $t("tabs.learn") }}</ion-label>
            </ion-tab-button>

            <ion-tab-button
              v-if="featureFlagStore.isFlagEnabled('release-page-jobs-home')"
              @keydown.enter="$router.push({ name: 'Jobs' })"
              tab="jobs"
              href="/tabs/jobs"
            >
              <ion-icon :icon="briefcaseOutline" />
              <ion-label>Jobs</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="tools-tab"
              v-if="
                featureFlagStore.isFlagEnabled('release-page-tools-home', true)
              "
              tab="tools"
              href="/tabs/tools"
              @keydown.enter="$router.push({ name: 'Tools' })"
            >
              <ion-icon aria-hidden="true" :icon="compassOutline" />
              <ion-label aria-label="Tools">{{ $t("tabs.tools") }}</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="info-tab"
              @keydown.enter="$router.push({ name: 'Information' })"
              tab="info"
              href="/tabs/info"
            >
              <ion-icon aria-hidden="true" :icon="peopleOutline" />
              <ion-label aria-label="Info">{{ $t("tabs.info") }}</ion-label>
            </ion-tab-button>
          </nav>
        </ion-tab-bar>
      </div>
      <ion-menu
        content-id="main-content"
        class="mobile-navigation-container"
        data-test="mobile-navigation"
      >
        <ion-header>
          <ion-toolbar class="mobile-navigation-toolbar">
            <ion-buttons slot="start">
              <ion-menu-toggle>
                <ion-icon
                  :icon="closeSharp"
                  class="mobile-navigation-close"
                  color="primary"
                  size="large"
                  aria-hidden="true"
                ></ion-icon>
              </ion-menu-toggle>
            </ion-buttons>
            <ion-title :class="menuHeaderImage"></ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content force-overscroll="false">
          <ion-tab-bar data-test="tab-bar-mobile">
            <ion-tab-button
              @keydown.enter="
                $router.push({ name: 'Home' });
                toggleMenu();
              "
              @click="toggleMenu()"
              tab="home"
              href="/tabs/home"
              data-test="home-tab-mobile"
            >
              <ion-icon aria-hidden="true" :icon="homeOutline"></ion-icon>
              <ion-label aria-label="Home">{{
                $t("tabs.mobile.home")
              }}</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="learn-tab-mobile"
              v-if="
                featureFlagStore.isFlagEnabled(
                  'release-page-learn-and-grow-home',
                  true
                )
              "
              @keydown.enter="
                $router.push({ name: 'Learn and Grow' });
                toggleMenu();
              "
              @click="toggleMenu()"
              tab="learn"
              href="/tabs/learn-home"
            >
              <ion-icon aria-hidden="true" :icon="trophyOutline" />
              <ion-label aria-label="Learn">{{
                $t("tabs.mobile.learn")
              }}</ion-label>
            </ion-tab-button>
            <ion-tab-button
              v-if="featureFlagStore.isFlagEnabled('release-page-jobs-home')"
              @keydown.enter="
                $router.push({ name: 'Jobs' });
                toggleMenu();
              "
              @click="toggleMenu()"
              tab="jobs"
              href="/tabs/jobs"
            >
              <ion-icon :icon="briefcaseOutline" />
              <ion-label>Jobs</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="tools-tab-mobile"
              v-if="
                featureFlagStore.isFlagEnabled('release-page-tools-home', true)
              "
              tab="tools"
              href="/tabs/tools"
              @keydown.enter="
                $router.push({ name: 'Tools' });
                toggleMenu();
              "
              @click="toggleMenu()"
            >
              <ion-icon aria-hidden="true" :icon="compassOutline" />
              <ion-label aria-label="Tools">{{
                $t("tabs.mobile.tools")
              }}</ion-label>
            </ion-tab-button>

            <ion-tab-button
              data-test="info-tab-mobile"
              tab="info"
              href="/tabs/info"
              @keydown.enter="
                $router.push({ name: 'Information' });
                toggleMenu();
              "
              @click="toggleMenu()"
            >
              <ion-icon aria-hidden="true" :icon="peopleOutline" />
              <ion-label aria-label="Info">{{
                $t("tabs.mobile.info")
              }}</ion-label>
            </ion-tab-button>
          </ion-tab-bar>
        </ion-content>
        <ion-footer v-if="showBrandLogo === true">
          <div class="logo-box">
            <ion-label class="watermark">{{
              $t("loadingScreen.poweredBy")
            }}</ion-label>
            <span class="apm-logo"></span>
          </div>
        </ion-footer>
      </ion-menu>
    </ion-tabs>
    <div
      v-if="featureFlagStore.isFlagEnabled('configure-component-chat', false)"
      class="chat-placeholder"
    >
      <ChatIcon></ChatIcon>
    </div>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import SkipLink from "@/components/SkipLink/SkipLink.vue";
import { closeSharp } from "ionicons/icons";
import {
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenu,
  IonMenuToggle,
  IonPage,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToolbar,
  menuController,
} from "@ionic/vue";
import ChatIcon from "@/components/ChatIcon/ChatIcon";
import {
  bookmarksOutline,
  briefcaseOutline,
  clipboardOutline,
  compassOutline,
  homeOutline,
  peopleOutline,
  trophyOutline,
} from "ionicons/icons";
import { useFeatureFlagStore } from "@/store";
import { useLocaleStore } from "@/store";
import EnvironmentConfig from "@/EnvironmentConfig";

export default defineComponent({
  name: "TabsPage",
  components: {
    ChatIcon,
    IonButtons,
    IonContent,
    IonFooter,
    IonHeader,
    IonIcon,
    IonLabel,
    IonMenu,
    IonMenuToggle,
    IonPage,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonTitle,
    IonToolbar,
    SkipLink,
  },
  setup() {
    const featureFlagStore = useFeatureFlagStore();
    const localeStore = useLocaleStore();
    const showBrandLogo = EnvironmentConfig.FeatureToggles.BrandShowLogo;

    const toggleMenu = async () => {
      await menuController.toggle();
    };

    return {
      bookmarksOutline,
      briefcaseOutline,
      clipboardOutline,
      closeSharp,
      compassOutline,
      featureFlagStore,
      homeOutline,
      localeStore,
      peopleOutline,
      trophyOutline,
      toggleMenu,
      showBrandLogo,
    };
  },
  computed: {
    themeName() {
      return this.localeStore.getCurrentLocaleTheme.toLowerCase();
    },
    tabbarImage() {
      switch (this.themeName) {
        case "sg": // singapore
          return "ion-tab-bar-sg";
        case "us": // united states
          return "ion-tab-bar-us";
        default:
          return "ion-tab-bar-global";
      }
    },
    menuHeaderImage() {
      switch (this.themeName) {
        case "sg": // singapore
          return "mobile-navigation-header-sg";
        case "us": // united states
          return "mobile-navigation-header-us";
        default:
          return "mobile-navigation-header";
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";

.chat-placeholder {
  min-width: 76px;
  max-width: 168px;
}

/* Mobile Design elements */
.navigation-container {
  display: none;
}

ion-tab-bar {
  background: white;
  width: var(--mobile-nav-width);
  height: calc(100% - 6px);
  overflow: hidden;
  padding-top: 5px;
  flex-direction: column;
  place-content: flex-start;
}

ion-tab-button {
  flex-direction: row;
  background: white;
  width: 100%;
  height: 60px;
  flex-grow: 0;
  place-content: flex-start;
  margin: 0;
  max-width: unset;
  padding-left: 20px;
  --background-focused: var(--ion-color-secondary);
  --ripple-color: var(--ion-color-secondary);
  --color-selected: var(--ion-color-secondary);
  --background-focused-opacity: 0.2;
  --padding-start: 0;
  --padding-end: var(--spacing-12);
  --background-focused: var(--ion-color-secondary);
  --ripple-color: var(--ion-color-secondary);
  --color-selected: var(--ion-color-secondary);
  --background-focused-opacity: 0.2;
  --color-focused: var(--ion-color-secondary);
  display: inline-block;
}

ion-tab-button.tab-selected {
  height: 60px;
  text-decoration: underline;
  color: var(--ion-color-secondary);
  --background-focused: var(--ion-color-secondary);
  --ripple-color: var(--ion-color-secondary);
  --color-selected: var(--ion-color-secondary);
  --background-focused-opacity: 0.2;
}

ion-tab-button.tab-selected::after,
ion-tab-button.ion-focused::after {
  content: "";
  transition: opacity 0.3s ease-out;
  width: 5px;
  height: 38px;
  background: var(--ion-color-secondary);
  border-radius: 4px 0px 0px 4px;
  display: block;
  position: relative;
  left: 168px;
  bottom: 50px;
  opacity: 1;
  margin: unset;
}

ion-tab-button.ios::after {
  left: calc(var(--mobile-nav-width) - 25px); // width of the selected indicator
}

ion-tab-button > ion-icon {
  padding: 5%;
}

.tabs-inner {
  margin-left: var(--mobile-nav-width);
}

ion-label {
  margin-bottom: 6px;
  font-size: 16px;
  margin-bottom: -3px;
}

ion-icon {
  max-height: 22px;
  max-width: 22px;
  margin: 6px 0px 2px 0px;
}

.mobile-navigation-toolbar {
  --min-height: 69px;
}

.mobile-navigation-close {
  font-size: 42px;
  max-height: 42px;
  max-width: 42px;
  margin-left: 6px;
  cursor: pointer;
}

.mobile-navigation-header {
  content: url("../../assets/logos/apm.svg");
  height: 69px;
}

.mobile-navigation-header-sg {
  content: url("../../assets/logos/sg.svg");
  height: 69px;
}

.mobile-navigation-header-us {
  content: url("../../assets/logos/us.png");
  height: 69px;
  width: auto;
  padding: 0px 76px;
}

ion-menu {
  --width: var(--mobile-nav-width);
}

/* make the menu shadow a bit darker */
ion-menu::part(backdrop) {
  background-color: rgba(0, 0, 0, 1);
}

ion-menu::part(container) {
  box-shadow: 4px 0px 16px rgba(0, 0, 0, 0.33);
}

.logo-box {
  border-top: 2px solid
    var(
      --ion-toolbar-border-color,
      var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.2)))
    );
  padding: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.watermark {
  font-size: 10px;
  line-height: 42px;
  text-align: center;
  color: var(--label-text);
}

.apm-logo {
  background: url("../../assets/logos/apm.svg");
  width: 72px;
  height: 42px;
  background-repeat: round;
}

/* Desktop layout */
/* Using SCSS Medium breakpoint, Only show vertical nav on iPad landscape and up*/
@include breakpoint(medium) {
  .navigation-container {
    display: contents;
    position: absolute;
  }
  ion-tab-button {
    padding-left: 0px;
    height: 50px;
    --padding-start: var(--spacing-12);
  }
  ion-tab-button.tab-selected {
    height: 50px;
  }
  .ion-tab-bar-global::before {
    content: url("../../assets/logos/apm.svg");
    transform: scale(0.383, 0.383) translate(-38.3%, -38.3%);
    height: 69px;
    width: 100%;
    padding-top: 9px;
    padding-bottom: 11px;
    border-bottom: 1px solid var(--lighter-grey);
  }
  .ion-tab-bar-sg::before {
    content: url("../../assets/logos/sg.svg");
    transform: scale(0.75, 0.75);
    height: 69px;
    width: 100%;
    padding-top: 9px;
    padding-bottom: 11px;
    border-bottom: 1px solid var(--lighter-grey);
  }
  .ion-tab-bar-us::before {
    content: "";
    background-image: url("../../assets/logos/us.png");
    transform: scale(0.9);
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    height: 69px;
    width: 100%;
    padding-top: 9px;
    padding-bottom: 11px;
    border-bottom: 1px solid var(--lighter-grey);
  }
  ion-tab-bar {
    position: fixed;
    left: 0;
    width: var(--desktop-nav-width);
    height: 100vh;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  ion-tab-button {
    margin: 10px 0;
  }
  //This is just to make the iOS indicator show ligned up, its default host css makes the buttons 10px bigger.
  ion-tab-button.ios::after {
    left: calc(var(--desktop-nav-width) - 5px);
  }
  ion-tab-button.tab-selected::after,
  ion-tab-button.ion-focused::after {
    bottom: 44px;
  }
  ion-tab-button > ion-icon {
    padding: 10%;
  }
  .tabs-inner {
    margin-left: var(--desktop-nav-width);
  }
}
</style>

<!-- unscoped style to affect generated, due to it being a shadow dom element, scoped won't work. -->
<style lang="scss">
@import "@/common/theme/breakpoints.scss";

@include breakpoint(medium) {
  .tabs-inner {
    margin-left: var(--desktop-nav-width);
  }
}
</style>
